<template>
  <v-card class="mx-auto" max-width="1200" outlined>
    <v-container>
      <div class="itemArea px-2">
        <div v-for="item in items" :key="item.uuid">
          <div class="p-postEditor__itemWrapper">
            <with-review-button-block
              v-if="!item._destroy"
              :key="item.id"
              :item="item"
            >
              <item-preview :item="item" />
            </with-review-button-block>
          </div>
        </div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import ItemPreview from '../parts/ItemPreview'
import WithReviewButtonBlock from '../parts/comments/WithReviewButtonBlock'
import { mapState } from 'vuex'

export default {
  components: {
    ItemPreview,
    WithReviewButtonBlock
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      items: (state) => state.PostEditor.post.items
    })
  }
}
</script>

<style scoped></style>
